import React from 'react';
import './ScrapbookHeader.css';

const ScrapbookHeader: React.FC = () => {
    return (
        <div className="scrapbook-title">
            <div className="title-main">
                <span className="title-yoyo">
                    Yoyo
                </span>
                <span className="title-ampersand">
                    &
                </span>
                <span className="title-steven">
                    Steven
                </span>
            </div>
            <div className="title-tagline">
                Our Digital Scrapbook
            </div>
        </div>
    );
};

export default ScrapbookHeader;